<template>
    <h6 class="fw-bold">
        Payers
        <span class="text-danger ms-1">*</span>
    </h6>
    <div class="d-flex flex-row align-items-center mb-1 card p-2 w-100 overflow-auto" v-if="!isAddPayerRequested">
        <div class="form-group d-flex mb-0">
            <label class="me-2 mt-2">Payer Status</label>
            <div>
                <div class="btn-group btn-group-toggle" data-bs-toggle="buttons">
                    <label
                        :class="`btn btn-outline-secondary font-size-xs ${isCurrent ? '' : 'active'}`"
                        @click="setIsCurrent(false)"
                    >
                        <input type="radio" hidden autocomplete="off" />
                        All
                    </label>
                    <label
                        :class="`btn btn-outline-secondary font-size-xs ${isCurrent ? 'active' : ''}`"
                        @click="setIsCurrent(true)"
                    >
                        <input type="radio" hidden autocomplete="off" />
                        Current
                    </label>
                </div>
            </div>
        </div>
        <div class="form-group row form-inline mb-0 ms-3" v-if="!isCurrent">
            <label class="mt-1 pe-0 col">Payer Type</label>
            <select class="form-select col" name="patient-payer-option" v-model="selectedType">
                <option v-for="patientPayerOption of patientPayerOptions" :value="patientPayerOption">
                    {{ patientPayerOption }}
                </option>
            </select>
        </div>
        <button class="btn btn-sm btn-primary ms-auto" @click="openAddPayer()">Add Payer</button>
    </div>
    <section
        :class="`card px-lg-5 py-2 mb-2 animated w-100 ${isAddPayerRequested ? 'faster fadeInDown' : 'slow fadeOutUp'}`"
        v-if="isAddPayerRequested"
    >
        <h5 class="text-capitalize">Add Payer</h5>
        <PayorForm
            v-if="newPatientPayer"
            :payer="newPatientPayer"
            :referral="referral"
            :is-loading="isAddPayerInProgress"
            :medicare-ids="medicareIds"
            :is-add-form="true"
            :provider-id="providerId"
            ref="payerForm"
        />
        <div class="text-center mt-1" v-if="!isAddPayerInProgress">
            <button type="button" class="btn btn-primary btn-md" @click="saveNewPayer()">Add Payer</button>
            <button type="button" class="btn btn-outline-secondary btn-md ms-2" @click="closeAddPayer()">Cancel</button>
        </div>
    </section>
    <Pagination ref="payersPagination" :pageChanged="pageChangedCallback" :isLoading="isLoading">
        <table id="PatientPayor__Table" class="table table-responsive-md border border-gray">
            <thead>
                <tr class="table-header">
                    <th v-if="hasData">
                        <SortableTh
                            :sort-by="sortBy"
                            v-on:sortByUpdated="sortByUpdated"
                            :sort-order="sortOrder"
                            v-on:sortOrderUpdated="sortOrderUpdated"
                            sort-string="type"
                        >
                            Payer Type
                        </SortableTh>
                    </th>
                    <th v-else>Payer Type</th>
                    <th>Payer</th>
                    <th>Member ID</th>
                    <th>Group Name</th>
                    <th>Group ID</th>
                    <th v-if="hasData">
                        <SortableTh
                            :sort-by="sortBy"
                            v-on:sortByUpdated="sortByUpdated"
                            :sort-order="sortOrder"
                            v-on:sortOrderUpdated="sortOrderUpdated"
                            sort-string="effectiveDate"
                            >Effective Date</SortableTh
                        >
                    </th>
                    <th v-else>Effective Date</th>
                    <th class="text-end">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr class="table-empty" v-if="!isLoading && !isError && !hasData">
                    <td :colspan="columns">
                        <h3>No Payers Found.</h3>
                    </td>
                </tr>
                <tr v-if="isLoading" v-for="i of loadingCount" class="table-loading">
                    <td v-for="i of columns">
                        <span class="shimmer-loading"></span>
                    </td>
                </tr>
                <tr class="table-error" v-if="!isLoading && isError">
                    <td :colspan="columns">
                        <ErrorMessageHandler title="Payers" :try-again="resetList" />
                    </td>
                </tr>
            </tbody>
            <PayorRow
                v-if="!isLoading && !isError && hasData"
                v-for="item of page.items"
                :payer="item"
                :referral="referral"
                :columns="columns"
                :payor-type-enum="payorTypeEnum"
                :medicare-ids="medicareIds"
                :reset-list="resetList"
                :update-patient-payor="updatePatientPayor"
                :delete-patient-payor="deletePatientPayor"
            />
        </table>
    </Pagination>
</template>

<script lang="ts" src="./PayorTable.ts"></script>
